import axios from "axios";
import CryptoJS from "crypto-js";

const secretKey = "12345678912345698745632165498712"; 
const EncryptionIV = "1234569874123659";

export const encryptData = (data: string) => {
  return CryptoJS.AES.encrypt(
    data,
    CryptoJS.enc.Utf8.parse(secretKey),
    {
      iv: CryptoJS.enc.Utf8.parse(EncryptionIV),
    }
  ).toString();
};

export const decryptData = (encrypted: string) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      encrypted,
      CryptoJS.enc.Utf8.parse(secretKey),
      { iv: CryptoJS.enc.Utf8.parse(EncryptionIV) }
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption failed:", error);
    return "";
  }
};


export const GetAllDoctorsService = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/GetAllDoctors`);
        return response;
    } catch (error: any){
        throw new Error(`GetAllDoctorsService error: ${error?.message}`);
    }
}

export const GetDetailById = async (doctorId: number) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorById?DrId=${doctorId}`);
        return response;
    } catch (error: any) {
        throw new Error(`GetDetailById error: ${error?.message}`);
    }
}

export const GetDoctorBySpeciality = async (specializationId: number) => {

    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorBySpeciality?SpecilizationId=${specializationId}`);
        return response;
    } catch (error: any) {
        throw new Error(`GetDoctorBySpeciality error: ${error?.message}`);
    }
}

export const GetSpecialitiesService = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/GetSpecialization`);
        return response;

    } catch (error: any) {
        console.error("Getting Error in get doctors", error)

    }
}